"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import ElPhoneVerifyCodeInput from "@/app_views/framework/components/form/ElPhoneVerifyCodeInput.vue";
const TotpVerify = () => import("@/app_views/framework/components/form/ElPhoneVerifyCodeInput.vue");
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { AccountSessionMixins } from "@/service/account-session";
import i18n from "@/lang";
export class VerifyPhoneForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.phone_prefix = "+86";
    this.phone = "";
    this.verify_code = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "phonelogin.please_enter_your_mobile_phone_number"
      ),
      trigger: "blur"
    }
  ])
], VerifyPhoneForm.prototype, "phone", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("verify_phone_dialog.verify_code_rule"),
      trigger: "blur"
    }
  ])
], VerifyPhoneForm.prototype, "verify_code", 2);
let VerifyPhoneDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.controller = new VerifyPhoneForm();
    this.lockName = "totp-code-verify";
    this.totp_code = null;
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(lockName, row) {
    return __async(this, null, function* () {
      this.lockName = lockName;
      this.totp_code = row;
      this.controller.phone = this.$session.account;
      this._verfiy_phone_dialog.show();
    });
  }
  sendPhoneCode(lock) {
    return __async(this, null, function* () {
      try {
        yield API.post("api://base.app/api/v1/verify_code/send", {
          "phone_prefix": this.controller.phone_prefix,
          "code_type": 14,
          "phone": this.controller.phone
        });
        this.$message(this.$i18n.t("verify_phone_dialog.form.code_send_tip", { "phone": this.controller.phone }));
        lock(120);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  VerifyCode() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth/api/v1/verify-code`, {
          "phone": this.controller.phone,
          "phonePrefix": this.controller.phone_prefix,
          "code": this.controller.verify_code,
          "codeType": 14
        });
        if (this.lockName === "totp-code-verify") {
          yield API.put(`api://base.local/storages/session/totpCode`, {
            "message": "no.need.verify",
            "model": "no.need.verify"
          });
        }
        if (this.lockName === "totp-qrcode-verify") {
          yield API.put(`api://base.local/storages/session/totpQrcode`, {
            "message": "no.need.verify",
            "model": "no.need.verify"
          });
        }
        this._verfiy_phone_dialog.hide();
        this.controller.verify_code = "";
        this.$emit("openTotpDialog", this.lockName, this.totp_code);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    this._verfiy_phone_dialog.hide();
    this.controller.phone = "";
    this.controller.verify_code = "";
  }
};
__decorateClass([
  Ref("verifyPhoneDialog")
], VerifyPhoneDialog.prototype, "_verfiy_phone_dialog", 2);
__decorateClass([
  Ref("phone_verify_code")
], VerifyPhoneDialog.prototype, "_phone_verify_code", 2);
VerifyPhoneDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      ElPhoneVerifyCodeInput,
      TotpVerify,
      UiForm,
      UiSubmit
    }
  })
], VerifyPhoneDialog);
export {
  VerifyPhoneDialog as default
};
